<template>
  <div>
    <section class="py-5">
      <div class="container-fluid">
        <div class="col-12 sliderDetails">
          <p class="movieCat">
            <!-- ANIMATION SPECIAL -->
            {{ Title }}
            <span class="txt-link">
              <router-link class="ml-4 mr-2" to>{{ SubTitle }}</router-link>
              <!-- <img
                id="tooltip-4"
                src="@/assets/img/svg/info-rd-icon.svg"
                class="rounded-circle"
              /> -->
              <!-- <button class="btn btn-danger viewmore-btn mr-4" @click="showModal = true">Know more</button> -->
            </span>
            <b-modal v-model="showModal" ok-variant="danger">
              <ul>
                <li>
                  We have selected these movies for special occasion for you to
                  enjoy exclusively only for you.
                </li>
                <li>Join the screening by booking the tickets.</li>
                <li>Enjoy Exclusive screening of your favorite movie.</li>
              </ul>
            </b-modal>
            <!-- ToolTip -->
            <b-tooltip target="tooltip-4" placement="right">
              
            </b-tooltip>
            <!-- <span class="link ml-2"><router-link :to="{ name: 'nowShowingList'}">(See All)</router-link></span> -->
          </p>
        </div>
        <div class="row" v-if="OwnScreening.length > 0">
          <div class="col-6 col-md-4 col-lg-3 col-xl-2 mb-4" v-for="(singleMovie, singleMovieIndex) in OwnScreening"
            :key="singleMovieIndex">
            <div class="movieSlider-container mx-auto text-center">
              <div class="img-container">
                <router-link :to="{
                  name: 'createScreen',
                  params: { movieId: singleMovie.ID, categoryId: 4 }
                }">
                  <img :src="singleMovie.Image" alt class="img-fluid mx-auto banner" />
                </router-link>

                <div class="img-logo">
                  <router-link :to="{
                    name: 'createScreen',
                    params: { movieId: singleMovie.ID, categoryId: 4 }
                  }">
                    <!-- <img src="@/assets/img/svg/gogo-small-icon.svg" class="img-fluid" /> -->
                  </router-link>
                </div>
              </div>
              <div class="text-center mx-auto pt-2 pt-md-3 movieSliderInfo">
                <p class="mb-0 title">{{ singleMovie.Name }}</p>
                <ul class="list-inline mb-0 mInfo">
                  <li class="list-inline-item">{{ singleMovie.Year }}</li>
                  <li class="list-inline-item">|</li>
                  <li class="list-inline-item">{{ singleMovie.Rated }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row container-fluid" v-if="NextPage && loadingData == false">
          <div class="col-12 text-center">
            <img src="@/assets/img/loadMore.gif" class="load-more" />
          </div>
        </div>
      </div>
    </section>

    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="0"></div>

    <!-- SPECIAL SCREENINGS MOVIES SLIDER -->
    <!-- <section class="bg-light py-2">
      <div class="container-fluid my-4">
        <SpecialScreenings />
      </div>
    </section>-->
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";

//   import NowShowing from "@/components/partials/nowShowingSlider.vue";
import SpecialScreenings from "@/components/partials/SpecialScreeningsSlider.vue";
import loader from "@/components/partials/loader.vue";
//   import OwnScreening from "@/components/partials/OwnScreeningSlider.vue";
//   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";

export default {
  name: "searchResult",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick,
    loader,
    SpecialScreenings
  },

  data() {
    return {
      showModal: false,
      dateTimeSlider: {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6,
        dots: false,
        responsive: [
          {
            breakpoint: 1900,
            settings: {
              slidesToShow: 7,
              slidesToScroll: 4,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3.1,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2
            }
          }
        ]
      },
      movieSlider: {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5.5,
        slidesToScroll: 4,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      PageNo: 0,
      NextPage: true,
      OwnScreening: [],
      loadingData: true,
      SubTitle: "Gog Library",
      Title: ""
    };
  },
  mounted() {
    this.getNowShowingData();
  },
  methods: {
    loadMore: function () {
      if (this.loadingData && this.NextPage && this.PageNo > 0) {
        this.loadingData = false;
        setTimeout(() => {
          this.getNowShowingData();
        }, 1000);
      }
    },
    getNowShowingData: function () {
      let payload = {
        CategoryID: 3,
        Version: "1"
      };
      payload["PageNo"] = this.PageNo;
      makeRequest("/GetShows/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          // this.OwnScreening = res.data.shows[2].Movies;
          if (this.PageNo == 0) {
            this.OwnScreening = res.data.Shows.Movies;
          } else {
            res.data.Shows.Movies.map(x => {
              this.OwnScreening.push(x);
            });
          }
          this.Title = res.data.Categories[2].CategoryName.toUpperCase();
          this.PageNo = res.data.Shows.PageNo;
          this.NextPage = res.data.Shows.Next;
          this.loadingData = true;
        })
        .catch(error => {
          console.log("Error", error);
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/pages/miniFestivalsList.vue